import { useState, useEffect } from 'react';
import { placeBusinessService } from '../services/api';
import { PlaceBusinessInfo, UpdatePlaceBusinessInfoRequest } from '../types/auth';

export const usePlaceBusinessInfo = (placeId: string | null) => {
  const [businessInfo, setBusinessInfo] = useState<PlaceBusinessInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Carregar dados empresariais do place
  const loadBusinessInfo = async () => {
    if (!placeId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const data = await placeBusinessService.getBusinessInfo(placeId);
      setBusinessInfo(data);
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Erro ao carregar dados empresariais');
      console.error('Erro ao carregar informações empresariais:', err);
    } finally {
      setLoading(false);
    }
  };

  // Atualizar informações empresariais
  const updateBusinessInfo = async (data: UpdatePlaceBusinessInfoRequest): Promise<boolean> => {
    if (!placeId) return false;

    try {
      setSaving(true);
      setError(null);
      const updatedInfo = await placeBusinessService.updateBusinessInfo(placeId, data);
      setBusinessInfo(updatedInfo);
      return true;
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Erro ao atualizar dados empresariais');
      console.error('Erro ao atualizar informações empresariais:', err);
      return false;
    } finally {
      setSaving(false);
    }
  };

  // Carregar dados quando placeId mudar
  useEffect(() => {
    loadBusinessInfo();
  }, [placeId]);

  return {
    businessInfo,
    loading,
    saving,
    error,
    loadBusinessInfo,
    updateBusinessInfo,
  };
};
